var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.canShowEndPromoButton)?_c('div',[(!_vm.value)?_c('v-btn',{attrs:{"color":"error","loading":_setup.sendMessageLoading},on:{"click":function($event){return _setup.buttonAction()}}},[_vm._v(" Finir la campagne ")]):_c('div',[_vm._v(" Campagne terminée le "+_vm._s(_setup.dateFormatted)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }